// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"23":"75775bb3","238":"ff90716f","419":"8e8fa949","626":"4d2ae434","772":"15393e79"}[chunkId] + ".js";
};